module.exports = __webpack_public_path__ + "static/media/pokemon-master.0a72d68f.PNG";